module.exports = __webpack_public_path__ + "img/934c5ac563868475ac2d6b3156133d67.png";